import * as luxon from "luxon";
import Tooltip from "../tooltip";
import {
  DateLike,
  toValidLuxonDateTime,
} from "../utils/dates/to-luxon-datetime";
import {
  DateDisplayFormatTypes,
  toValidLuxonDateTimeFormat,
} from "../utils/dates/to-valid-luxon-datetime-format";

const DateTime = ({
  date,
  format = luxon.DateTime.DATETIME_FULL,
  className = "",
  as,
  showTooltip = true,
  invalidMessage = "Invalid Date",
}: {
  date: DateLike;
  format?: DateDisplayFormatTypes;
  className?: string;
  as?: "div" | "span" | null;
  showTooltip?: boolean;
  invalidMessage?: string;
}) => {
  const dt = toValidLuxonDateTime(date);
  if (dt.isNothing()) {
    return null;
  }

  const formatted = dt.chain((d) => toValidLuxonDateTimeFormat(d, format));
  const fullDate = dt.chain((d) =>
    toValidLuxonDateTimeFormat(d, luxon.DateTime.DATETIME_FULL)
  );

  const C = as ?? "span";
  if (!showTooltip) {
    return <C className={className}>{formatted.orDefault(invalidMessage)}</C>;
  }

  return (
    <Tooltip content={fullDate.orDefault(invalidMessage)}>
      <C className={className}>{formatted.orDefault(invalidMessage)}</C>
    </Tooltip>
  );
};

export default DateTime;

export const DateDisplay = DateTime;
